import { Box, Container, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import GroupIcon from '@mui/icons-material/Group';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

const StyledContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(4),
  gridTemplateColumns: 'repeat(1, 1fr)',
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
}));

const features = [
  {
    icon: <SentimentVerySatisfiedIcon sx={{ fontSize: 40 }} />,
    title: 'Bring Levity',
    description: 'Markets can be a grind. Take a breath, smile, and maybe not take that 10% dip too personally.'
  },
  {
    icon: <GroupIcon sx={{ fontSize: 40 }} />,
    title: 'Build Community',
    description: 'Join a community of traders who understand the emotional rollercoaster of trading life.'
  },
  {
    icon: <TrendingUpIcon sx={{ fontSize: 40 }} />,
    title: 'Celebrate the Hustle',
    description: 'From panic to profit, we honor the emotional journey of every trade, win or lose.'
  },
  {
    icon: <AccountBalanceWalletIcon sx={{ fontSize: 40 }} />,
    title: 'Light on the Wallet',
    description: 'Designed to be fun and accessible, not a burden on your trading capital.'
  }
];

const Features = () => {
  return (
    <Box sx={{ py: 8, backgroundColor: '#ffffff' }}>
      <Container maxWidth="lg">
        <Typography variant="h2" sx={{ mb: 6, textAlign: 'center', color: '#1a237e' }}>
          Why Choose MUMMY & DADDY?
        </Typography>
        
        <StyledContainer>
          {features.map((feature, index) => (
            <div key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <Paper
                  elevation={3}
                  sx={{
                    p: 3,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      transition: 'transform 0.3s ease-in-out'
                    }
                  }}
                >
                  <Box sx={{ color: '#ff4081', mb: 2 }}>
                    {feature.icon}
                  </Box>
                  <Typography variant="h6" sx={{ mb: 2, color: '#1a237e' }}>
                    {feature.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {feature.description}
                  </Typography>
                </Paper>
              </motion.div>
            </div>
          ))}
        </StyledContainer>
      </Container>
    </Box>
  );
};

export default Features;
